




















































import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import OrderShippingfreeRuleApi from '@/api/order/order-shippingfree-rule/index'
@Component({
  components: {
    CustomForm,
  },
})
export default class PreStorageRules extends AbpBase {
  loading = false
  addPrestorerules: boolean = false
  prestoreRulesTitle: string = "新增订单运费规则"
  rulesForm: any = {
    min: null,
    max: null,
    calcType: null,
    shippingFee: null
  }
  ruleForm = {
    min: [{ required: true, type:"number", message: '请输入最小数', trigger: 'blur' }],
    max: [{ required: true, type:"number", message: '请输入最大数', trigger: 'blur' }],
    calcType: [{ required: true, type:"number", message: '请选择计费类型', trigger: 'change' }],
    shippingFee: [{ required: true, type:"number", message: '请输入运费', trigger: 'blur' }],
  }
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
  }
  filters = [
    {
      label: '关键字：',
      type: 'input',
      props: {
        placeholder: '请输入',
      },
      key: 'Filter',
    },
  ]
  columns1 = [
    {
      title: '最小数',
      key: 'min',
      align: 'center',
    },
    {
      title: '最大数',
      key: 'max',
      align: 'center',
    },
    {
      title: '计费类型',
      slot: 'calcType',
      align: 'center',
    },
    {
      title: '运费',
      key: 'shippingFee',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
      width: 300,
    },
  ]
  data1 = []
  mounted() {
    this.loadData()
  }
  onPageIndexChange(value) {
    this.pager.pageIndex = value
    let form = (this.$refs.lineForm as any).form
    this.loadData(form)
  }
  submitChange(form, valid) {
    if (valid) {
      this.pager.pageIndex = 1
      this.loadData(form)
    }
  }
  loadData(form = {}) {
    let keyWord = form['Filter']
    this.loading = true
    OrderShippingfreeRuleApi.getList(this.pager.pageSize, this.pager.pageIndex, keyWord).then((res) => {
      if (res.data && res.data.items.length) {
        this.pager.total = res.data.totalCount
        this.data1 = res.data.items
      }
      this.loading = false
    }).catch(err => {
      this.loading = false
    })
  }
  handleCommonAction(row, type) {
    switch (type) {
      case 'edit':
        this.handleEditStore(row)
        break
      case 'delete':
        this.handleDeleteStore(row)
        break
      default:
        break
    }
  }
  submitAuth() {
    let form: any = this.$refs.form
    form.validate(valid => {
      if (valid) {
        if (this.rulesForm.id) {
          OrderShippingfreeRuleApi.actionRules('put', this.rulesForm, this.rulesForm.id)
            .then((res) => {
              this.$Notice.success({ desc: '修改成功' })
              this.loadData()
              this.addPrestorerules = false
            })
        } else {
          OrderShippingfreeRuleApi.actionRules('post', this.rulesForm)
            .then((res) => {
              this.$Notice.success({ desc: '创建成功' })
              this.loadData()
              this.addPrestorerules = false
            })
        }
      }
    })
  }
  closeModal() {
    this.rulesForm = {
      min: null,
      max: null,
      calcType: null,
      shippingFee: null
    }
    this.addPrestorerules = false
  }
  // 编辑预存规则
  handleEditStore(row) {
    console.log(row);
    this.prestoreRulesTitle = '编辑订单运费规则'
    this.rulesForm = JSON.parse(JSON.stringify(row))
    this.addPrestorerules = true
  }
  /* 
    删除预存规则
   */
  handleDeleteStore(row) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.loading = true
        OrderShippingfreeRuleApi.actionRules('delete', null, row.id)
          .then((res) => {
            console.log(res)
            this.loading = false
            this.$Notice.success({ desc: '删除成功' })
            this.loadData()
          })
          .catch((err) => {
            this.loading = false
          })
      },
    })
  }
  /**
   * 添加预存规则
   */
  handleAddShop() {
    this.prestoreRulesTitle = '新增订单运费规则'
    this.rulesForm = {
      min: null,
      max: null,
      calcType: null,
      shippingFee: null
    }
    this.addPrestorerules = true
  }
}
